import CRMRetargetinSegmentsPage from "./CRMRetargetinSegmentsPage";

export default CRMRetargetinSegmentsPage;
